export function quotaBarColor(pct: number): string {
  if (pct > 0.9) return 'var(--red)'
  if (pct > 0.7) return 'var(--amber)'
  return 'var(--accent)'
}
